import { useState } from 'react';

import { useAlert, useAuth } from '@spotify/confidence-core-react';

import { getLoginAuthErrorMessage } from '../signupUtils';

type UseAccountLoginResult = {
  error?: Error;
  loading: boolean;
  login: () => Promise<void>;
};

export const useAccountLogin = (loginId: string): UseAccountLoginResult => {
  const alert = useAlert();
  const [loggingIn, setLoggingIn] = useState(false);
  const { isLoading, loginWithRedirect, error } = useAuth();

  const login = async (): Promise<void> => {
    setLoggingIn(true);
    try {
      await loginWithRedirect({
        appState: {
          returnTo: '/',
        },
        authorizationParams: {
          organization: loginId,
        },
      });
    } catch (loginError) {
      alert.post({
        severity: 'error',
        message: getLoginAuthErrorMessage(loginError),
      });
    } finally {
      setLoggingIn(false);
    }
  };

  return {
    error,
    loading: isLoading || loggingIn,
    login,
  };
};
